export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.299f33041ec1bf0cdb0d.worker.js");
}
